"use client";

import { useState } from "react";
import { SearchIcon } from "@/components/feature-icons";

const CHIPS: { label: string; target: string }[] = [
  { label: "Build a person picture", target: "person-intelligence" },
  { label: "Find a current address", target: "address-intelligence" },
  { label: "Review address history", target: "person-intelligence" },
  { label: "Find occupants", target: "address-intelligence" },
  { label: "Find company connections", target: "company-intelligence" },
  { label: "Validate a mobile", target: "contact-record-status" },
  { label: "Check company information", target: "company-intelligence" },
  { label: "Search property ownership", target: "property-intelligence" },
  { label: "Trace a person", target: "tracing" },
  { label: "Integrate Person Intelligence", target: "api-access" },
];

export function FeatureFinder() {
  const [query, setQuery] = useState("");
  const q = query.trim().toLowerCase();

  return (
    <section className="border-b border-outline-variant/50 bg-background px-container-padding py-16">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="text-2xl font-bold tracking-tight text-brand-navy md:text-3xl">
          What do you want to do?
        </h2>

        <div className="relative mx-auto mt-6 max-w-xl">
          <SearchIcon className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-on-surface-variant" />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search features or tasks..."
            aria-label="Search features or tasks"
            className="w-full rounded-xl border border-outline-variant bg-white py-3.5 pl-12 pr-4 text-brand-navy shadow-sm outline-none placeholder:text-on-surface-variant/70 focus:border-brand-cyan focus:ring-2 focus:ring-brand-cyan/30"
          />
        </div>

        <div className="mt-5 flex flex-wrap justify-center gap-2.5">
          {CHIPS.map((chip) => {
            const match = !q || chip.label.toLowerCase().includes(q);
            return (
              <a
                key={chip.label}
                href={`#${chip.target}`}
                aria-hidden={!match || undefined}
                tabIndex={match ? undefined : -1}
                className={`rounded-full border px-4 py-2 text-sm font-medium transition-all ${
                  match
                    ? "border-outline-variant bg-white text-brand-navy shadow-sm hover:border-brand-cyan hover:text-brand-electric"
                    : "pointer-events-none border-transparent bg-transparent text-on-surface-variant/40"
                } ${q && match ? "border-brand-cyan ring-2 ring-brand-cyan/30" : ""}`}
              >
                {chip.label}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
